import { usePreferences } from "../../../../contexts/PreferencesContext";

const LogsDash = (props) => {const { t } = usePreferences();
  let processo = props.processo;
  return (
    <>
        <div className="table-modern-card">
                    <div className="table-modern-scroll mb-0">
                        <table id="tech-companies-1" className="table table-striped" style={{ borderRadius: '2rem' }}>
                            <thead>
                                <tr>

                                    <th>Log</th>
                                    <th>Quantidade</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Total fiscais</td>
                                    <td>{processo.total_fiscais}</td>
                                </tr>
                                <tr>
                                    <td>Total corretores</td>
                                    <td>{processo.total_corretores}</td>
                                </tr>
                                <tr>
                                    <td>{t("ui_total_candidatos_878e3013")}</td>
                                    <td>{processo.total_alunos}</td>
                                </tr>
                                <tr>
                                    <td>{t("legacy_avaliadores_online")}</td>
                                    <td>{processo.avaliadores_online.length}</td>
                                </tr>
                                <tr>
                                    <td>{t("ui_candidatos_que_fizeram_login_14f0d12d")}</td>
                                    <td>{processo.alunos_login}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_a_tela_de_termos_e9f9141c")}</td>
                                    <td>{processo.tela_termos}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_a_tela_de_avaliacao_nao_i_a41a4375")}</td>
                                    <td>{processo.tela_avaliacao_nao_iniciada}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_a_tela_de_aceite_de_regra_da5f04ad")}</td>
                                    <td>{processo.entraram_alunos_aceite}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_a_tela_de_avaliacao_em_an_1b4c8a44")}</td>
                                    <td>{processo.entraram_alunos_prova}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_a_tela_de_avaliacao_final_7987b18b")}</td>
                                    <td>{processo.tela_avaliacao_finalizada}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_ausentes_906899d3")}</td>
                                    <td>{processo.ausentes_alunos}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_e_nao_finalizaram_fe2f36f7")}</td>
                                    <td>{processo.nao_finalizaram_alunos}</td>
                                </tr>

                                <tr>
                                    <td>{t("ui_candidatos_que_acessaram_e_finalizaram_c9793b24")}</td>
                                    <td>{processo.finalizaram_alunos}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
        </>);



};

export default LogsDash;